import React, { useState } from "react";
import { BASE_URL, getApiUrl } from "../utils/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

const ProductCard = ({ product, comboType, onComboSelect }) => {
  const {
    _id,
    productName,
    slugUrl,
    mainImage,
    price,
    originalPrice,
    discount,
    totalProducts,
    sizes,
  } = product;

  const displayName =
    productName?.length > 20
      ? productName.substring(0, 20) + "..."
      : productName;

  const [selectedSize, setSelectedSize] = useState("");
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  const openProductDetail = () => {
    if (!product.slugUrl) return toast.error("Product link not available");
    window.open(`${window.location.origin}/${product.slugUrl}`, "_blank");
  };

  const getGuestId = () => {
    let userId = localStorage.getItem("userId");
    if (!userId) {
      userId = "guest_" + Date.now();
      localStorage.setItem("userId", userId);
    }
    return userId;
  };
  const handleAddToCart = async () => {
    if (!selectedSize) return toast.warning("Select size");

    const userId = localStorage.getItem("userId");

    const res = await fetch(getApiUrl("cart-add"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        userId,
        productId: product.id,
        selectedSize,
        quantity: 1,
      }),
    });

    const data = await res.json();
    if (data.success) navigate("/bskian-cart");
  };

  const handleAddWishlist = async () => {
    try {
      let userId = localStorage.getItem("userId");
      if (!userId) {
        userId = "guest_" + Date.now();
        localStorage.setItem("userId", userId);
      }

      const res = await fetch(getApiUrl("wishlist-add"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId,
          productId: product.id,
        }),
      });

      const data = await res.json();

      if (data.success && data.message === "Already in wishlist") {
        toast.info("Already in wishlist 💙");
      } else if (data.success) {
        toast.success("Added to Wishlist ❤️");
      } else {
        toast.error(data.message || "Failed");
      }
    } catch (err) {
      toast.error("Something went wrong ❗");
    }
  };

  const availableSizes = sizes
    ? Object.keys(sizes).filter((size) => sizes[size] > 0)
    : [];

  return (
    <div className="product-card-wrapper" style={{ position: "relative" }}>
      {(comboType === "MIXED" || comboType === "BULK") && (
        <div className="combo-checkbox" onClick={(e) => e.stopPropagation()}>
          <input type="checkbox" onChange={() => setShowModal(true)} />
        </div>
      )}

      {discount > 0 && <div className="discount-peacock">{discount}% OFF</div>}

      <div
        className="product-img mb-2"
        onClick={openProductDetail}
        style={{ cursor: "pointer" }}
      >
        <img
          src={mainImage ? `${BASE_URL}${mainImage}` : ""}
          alt={productName || ""}
          className="w-100 h-48 object-cover rounded-md"
        />
      </div>

      <h5 className="product-title" onClick={openProductDetail}>
        {displayName}
      </h5>

      <h6 className="product-price text-center">
        ₹{price}{" "}
        {originalPrice && (
          <span className="product-original">₹{originalPrice}</span>
        )}
      </h6>

      <div className="product-info-row">
       

        <span className="product-stock-center">
          Stock: {totalProducts ?? 0}
        </span>

        
      </div>

      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-sm modal-dialog-centered">
            <div className="modal-content rounded-4">
              <div className="modal-header">
                <h5 className="modal-title fw-bold">Select Size</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body d-flex flex-wrap justify-content-center">
                {availableSizes.length > 0 ? (
                  availableSizes.map((size) => (
                    <button
                      key={size}
                      type="button"
                      className={`btn btn-outline-primary m-1 ${
                        selectedSize === size ? "active" : ""
                      }`}
                      onClick={() => setSelectedSize(size)}
                    >
                      {size} ({sizes[size]})
                    </button>
                  ))
                ) : (
                  <p className="text-danger">Out of stock</p>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary btn-sm w-100"
                  disabled={!selectedSize}
                  onClick={() => {
                    if (comboType === "MIXED" || comboType === "BULK") {
                      onComboSelect({
                        id: _id,
                        name: productName,
                        size: selectedSize,
                        price,
                        subcategoryId: product.subcategoryId,
                      });

                      setShowModal(false);
                    } else {
                      handleAddToCart();
                    }
                  }}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductCard;
